module.exports = __webpack_public_path__ + "static/media/2.9789e76e.svg";